import React from "react";
import useScreenBreakpoint from "@hooks/useScreenBreakpoint";
import ChartRefetchButton from "@components/ChartRefetchButton/ChartRefetchButton";
import { ChartActionsContainer, MobileUpdatedAtWrapper } from "./style";

interface ChartActionsProps {
  updatedAt: Date | number;
  refetchFunction: () => void;
}

const ChartActions: React.FC<ChartActionsProps> = ({ updatedAt, refetchFunction }) => {
  const { isMobileScreen } = useScreenBreakpoint();

  if (isMobileScreen) {
    return (
      <MobileUpdatedAtWrapper>
        <ChartRefetchButton updatedAt={updatedAt} refetchFunction={refetchFunction} />
      </MobileUpdatedAtWrapper>
    );
  }

  return (
    <ChartActionsContainer>
      <ChartRefetchButton updatedAt={updatedAt} refetchFunction={refetchFunction} />
    </ChartActionsContainer>
  );
};

export default ChartActions;
